import React, { useEffect, useState } from "react";
import { Form, Input, Table } from "antd";
import { useLocation } from "react-router-dom";
import type { TableColumnsType } from "antd";
import axios from "axios";
import "./InquiryInfo.css";

interface HistoryHppDataType {
  key: React.Key;
  item_code: string;
  date_trans: string;
  hpp: number;
}

const columns: TableColumnsType<HistoryHppDataType> = [
  {
    title: "Item Code",
    dataIndex: "item_code",
    key: "item_code",
  },
  {
    title: "Date Trans",
    dataIndex: "date_trans",
    key: "date_trans",
  },
  {
    title: "Hpp",
    dataIndex: "hpp",
    key: "hpp",
    render: (hpp: any) => {
      const num = Number(hpp);
      if (isNaN(num)) {
        return 'Rp 0';
      }
      return num.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' });
    },
  },
];

const formatNumber = (value: any): string => {
  const num = Number(value);
  if (isNaN(num)) {
    return "0";
  }
  return num.toLocaleString('id-ID');
};

const InquiryInfo: React.FC = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [historyData, setHistoryData] = useState<HistoryHppDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (location.state) {
      const dataFromState = location.state;

      form.setFieldsValue({
        item_code: dataFromState.item_code,
        item_name: dataFromState.item_name,
        average_cost: formatNumber(dataFromState.average_cost),
        on_order_qty: dataFromState.on_order_qty,
        warehouse_code: dataFromState.warehouse_code,
        warehouse_name: dataFromState.warehouse_name,
        location_code: dataFromState.location_code,
        location_name: dataFromState.location_name,
        sales_price: formatNumber(dataFromState.sales_price),
      });

      const fetchHistoryHpp = async (itemCode: string) => {
        setLoading(true);
        try {
          const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/spareparts/history_hpp`, {
            params: { item_code: itemCode }
          });
          const sortedData = response.data.sort((a: HistoryHppDataType, b: HistoryHppDataType) => {
            const partsA = a.date_trans.split('/').map(Number);
            const dateA = new Date(partsA[2], partsA[1] - 1, partsA[0]);
            const partsB = b.date_trans.split('/').map(Number);
            const dateB = new Date(partsB[2], partsB[1] - 1, partsB[0]);
            return dateB.getTime() - dateA.getTime();
          });
          setHistoryData(sortedData);
        } catch (error) {
          console.error("Failed to fetch HPP history:", error);
          setHistoryData([]);
        } finally {
          setLoading(false);
        }
      };

      if (dataFromState.item_code) {
        fetchHistoryHpp(dataFromState.item_code);
      }
    }
  }, [location.state, form]);


  return (
    <div
      id="iau9"
      style={{
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "117.65%",
      }}
    >
      <div className="gjs-grid-row" id="iyki">
        <div className="gjs-grid-column" id="iazz"></div>
      </div>
      <div className="gjs-grid-row" id="iw71">
        <div className="gjs-grid-column" id="iexm">
          <Form
            form={form}
            layout="horizontal"
            style={{ maxWidth: "100%" }}
            labelCol={{ style: { width: "230px" } }}
            wrapperCol={{ style: { width: "290px" } }}
            className="custom-info-1"
          >
            <Form.Item label="Item Code" name="item_code">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item className="item_name" label="Item Name" name="item_name">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Moving Code" name="moving_code">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Average Cost" name="average_cost">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item className="on_order_q" label="On Order Quantity" name="on_order_qty">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Warehouse Code" name="warehouse_code">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Warehouse Name" name="warehouse_name">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Location Code" name="location_code">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Location Name" name="location_name">
              <Input placeholder="" readOnly />
            </Form.Item>
            <Form.Item label="Sales Price" name="sales_price">
              <Input placeholder="" readOnly />
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className="gjs-grid-row" id="ioye6">
        <div className="gjs-grid-column" id="iot9r">
          <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px", color: "#333" }}>History Price HPP</h2>
          <Table<HistoryHppDataType> columns={columns} dataSource={historyData} loading={loading} rowKey="key" />
        </div>
      </div>
    </div>
  );
};


export default InquiryInfo;